import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import SelectComponent from "../../components/SelectComponent/SelectComponent";
import Addguest from "../horecaWidget/Addguest";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import lang from "../../assets/lang.png";
import DateComponent from "../horecaWidget/DateComponent";
import ReservationType from "../horecaWidget/ReservationType";
import TimeComponent from "../horecaWidget/TimeComponent";
import ReservationGroup from "../horecaWidget/ReservationGroup";
import { useDispatch, useSelector } from "react-redux";
import {
  checkGuestLimit,
  setDateLoading,
  setExtraProductData,
  setFreeTablesData,
  setGuestCount,
  setIsBackToHoreca,
  setIsOpenWidget,
  setLanguageID,
  setLanguageWords,
  setReservationGroupDatas,
  setReservationTypeDatas,
  toggleBookNowOpen,
  updateDefaultLanguage,
  updateReservationGroup,
  updateReservationType,
  updateSelectedDate,
  updateTime,
  updateTotalCount,
} from "../../store/slice/Addguest.slice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import BGIMG from "../../assets/BG.png";
import {
  FetchWidgetConfigDetails,
  GetGuestDetailsByKey,
  getCalenderDatas,
  getExtraProductDetails,
  getLanguageDetails,
  getReservationGroup,
  getReservationType,
  getReservationTypeBasedOnProducts,
  getWidgetSetUpPosition,
  getWidgetSettings,
  getWidgetTitleandInfo,
} from "../../api/HorecaWidget.service";
import { CheckCircleTwoTone } from "@mui/icons-material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  setLanguageLoaded,
  updateBlockedDates,
  updateButtonText,
  updateCombinationLang,
  updateFloating,
  updateGuestInfo,
  updateKey,
  updateLanguageData,
  updateWidgetConfig,
  updateWidgetSetting,
} from "../../store/slice/widgetSetting.slice";
import customParseFormat from "dayjs/plugin/customParseFormat";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import { ClearIcon } from "@mui/x-date-pickers/icons";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import { setCombinationList } from "../../store/slice/Activity.slice";
import { calculateEndTime, convertToTimeFormat } from "../../utils/utils";
import { getCombinationList } from "../../api/activity.service";
import WidgetComponent from "../ActivitiesWidget/WidgetComponent";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing

const HorecaComponent = ({ data,language,id}) => {

  const theme = useTheme();
  const {
    totalCount,
    selectedDate,
    reservType,
    time,
    reservGroup,
    adult,
    child,
    kid,
    baby,
    toddler,
    reservationGroupData,
    dateLoading,
    isBackToHoreca,
    defaultLanguage,
    selectedExtraProduct,
    languageWords,
    languageId,
    isOpenWidget,
    isGreaterThan10,
    freeTablesData,
    reservationTypeDatas,
  } = useSelector((store) => store.addGuest);
  const {
    WidgetSetting,
    widgetConfig,
    blockedDates,
    guestId,
  } = useSelector((store) => store?.widgetSettings);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reservTypeLoading, setReserveTypeLoading] = useState(false);
  const [reservationRequestMin, setResReqMin] = useState(0);
  const [isAddGuest, setIsAddGuest] = useState(false);
  const dateRef = useRef(null);
  const guestRef = useRef(null);
  const reservationType = useRef(null);
  const timeRef = useRef(null);
  const reservationGroupRef = useRef(null);
  const [isDateDropdownOpen, setIsDateDropdownOpen] = useState(false);
  const [isReservationType, setIsReservationType] = useState(false);
  const [isTimeComponent, setIsTimeComponent] = useState(false);
  const [isGrouptype, setIsTypeGroup] = useState(false);

  const fetchLanguageDetails = async () => {
    try {
      const response = await getLanguageDetails(data?.key);
      if (response?.status != 200) {
        console.error("Error fetching language details widget:", response);
        return;
      }
      dispatch(updateLanguageData(response?.data));
      const langParam = queryParams.get("lang");
      if (response?.data) {
        const defaultLang =
          !defaultLanguage && !langParam
            ? response?.data?.find((item) => item?.defaultLanguage)?.langcode
            : langParam
            ? langParam
            : defaultLanguage;
        localStorage.setItem(
          "widget",
          JSON.stringify({
            id: data?.idWidgetSetup,
            key: data?.key,
            lang: defaultLang,
          })
        );

        dispatch(updateDefaultLanguage(defaultLang));
        dispatch(setLanguageLoaded(true)); // Set the flag to true
        dispatch(setLanguageID(defaultLang?.idlanguage));
      }
    } catch (error) {
      console.error("Error fetching language details widget:", error?.message);
    }
  };
  const fetchWidgetSettings = async (language) => {
    try {
      const response = await getWidgetSettings(language, data?.key);
      if (response?.status !== 200 || !response?.data) {
        throw new Error(
          "Failed to fetch widget settings. Please try again later."
        );
      }
      dispatch(updateWidgetSetting(response?.data));
    } catch (error) {
      const errorMsg =
        error?.message ||
        "An unexpected error occurred while fetching widget settings.";
      console.error("Error fetching widget settings:", errorMsg);
    }
  };
  const fetchWidgetTitleandInfo = async (widgetSetupId, language) => {
    try {
      const response = await getWidgetTitleandInfo(widgetSetupId, language);
      if (response?.status != 200 || !response?.data) {
        throw new Error(
          "Failed to fetch widget title and info. Please try again later."
        );
      }
    } catch (error) {
      console.error("Error fetching widget settings:", error?.message);
    }
  };

  const getUnavailableCalenderDetails = async () => {
    dispatch(setDateLoading(true));
    try {
      const response = await getCalenderDatas(
        data?.key,
        totalCount,
        data?.idWidgetSetup,
        reservationRequestMin
      );
      if (response?.status != 200 || !response?.data) {
        throw new Error(
          "Failed to fetch unavailable dates. Please try again later."
        );
      }
      dispatch(updateBlockedDates(response?.data));
      dispatch(setDateLoading(false));
      return response;
    } catch (error) {
      console.error("Error fetching unavailable dates", error);
      dispatch(setDateLoading(false));
    }
  };

  const fetchReservationType = async () => {
    setReserveTypeLoading(true); // Start loading
    const parsedDate = dayjs(selectedDate, "DD-MM-YYYY", true);
    // Check if date is valid
    if (!parsedDate?.isValid()) {
      setReserveTypeLoading(false); // Stop loading on error
      return;
    }
    // Format the valid date into 'YYYY-MM-DD'
    const formattedDate = parsedDate.format("YYYY-MM-DD");
    const payload = {
      idwidgetsetup: parseInt(data?.idWidgetSetup),
      amount: parseInt(totalCount),
      date: formattedDate,
      key: data?.key,
      field2: false,
      field1GuestCount: parseInt(adult),
      field2GuestCount: parseInt(child),
      field3GuestCount: parseInt(kid),
      field4GuestCount: parseInt(baby),
      field5GuestCount: parseInt(toddler),
      reservationRequestMin: parseInt(reservationRequestMin),
      lang: language,
    };
    try {
      const response = await getReservationType(payload);
      if (response.status != 200 || !response?.data || response.length === 0) {
        throw new Error(
          "Failed to fetch reservation types. Please try again later."
        );
      }
      // Iterate over the response data
      const promises = response?.data?.map(async (item) => {
        const prodId = item?.idproducthoreca; // Assuming 'idproducthoreca' is the identifier
        // Initialize totalCost and vat to default values
        let totalCost = 0;
        let vat = null;
        if (prodId) {
          // Get cost data for the product using prodId
          const productData = await getReservationTypeBasedOnProducts(
            data?.key,
            prodId
          );
          // Calculate the total cost for this item using the guest counts
          totalCost =
            (productData?.price1 || 0) * parseInt(adult) +
            (productData?.price2 || 0) * parseInt(child) +
            (productData?.price3 || 0) * parseInt(kid) +
            (productData?.price4 || 0) * parseInt(baby) +
            (productData?.price5 || 0) * parseInt(toddler);
          vat = productData?.vat;
        }
        // Return the item with the total cost added
        return {
          ...item, // Copy the original item fields
          totalCost, // Add the calculated total cost
          vat,
        };
      });
      // Wait for all promises to complete
      const updatedResponse = await Promise.all(promises);
      // Dispatch the updated response with the total costs
      dispatch(setReservationTypeDatas(updatedResponse));
    } catch (error) {
      console.error("Error fetching reservation type:", error?.message);
    } finally {
      setReserveTypeLoading(false); // Stop loading after success or error
    }
  };

  const fetchWidgetSettingsDetails = async (lang) => {
    try {
      const response = await FetchWidgetConfigDetails(
        data?.key,
        data?.idWidgetSetup,
        lang,
        guestId
      );
      if (response?.status != 200 || !response?.data) {
        throw new Error(
          "Failed to fetch widget settings details. Please try again later."
        );
      }
      const result = response?.data?.basicLanguages?.reduce((acc, item) => {
        const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
        const data = item.widgetTranslateLanguages[0]?.name;
        acc[tag] = data; // Assign data to the key acc[tag]
        return acc;
      }, {});
      dispatch(updateWidgetConfig(response?.data));
      dispatch(updateButtonText(response?.data?.fields?.reservationButtonText));
      dispatch(setLanguageWords(result));
      dispatch(updateCombinationLang({
        bookReservation: result?.bookReservation,
        selectCategory:result?.selectCategory
      }))
    } catch (error) {
      console.error("Error fetching widget settings details:", error);
    }
  };

  const fetchGuestDetailsByToken = async () => {
    try {
      const response = await GetGuestDetailsByKey(
        widgetConfig?.token,
        data?.key,
        guestId
      );
      if (!response) {
        throw new Error(
          "Failed to fetch guest details. Please try again later."
        );
      }
      dispatch(updateGuestInfo(response));
    } catch (error) {
      console.error("Error fetching guest details by token:", error);
    }
  };
  useEffect(()=>{
    dispatch(updateKey(data?.key))
  },[data])
  useEffect(() => {
    if (widgetConfig?.token) {
      fetchGuestDetailsByToken();
    }
  }, [widgetConfig]);

  const nonEmptyFields = Object.keys(widgetConfig?.fields || {}) // Use the correct object
    .filter(
      (key) =>
        key.startsWith("field") && widgetConfig?.fields[key]?.trim() !== "" // Check if it exists and is not empty
    )
    .map((key) => widgetConfig.fields[key]);
  useEffect(() => {
      if(!language) fetchLanguageDetails();
  }, [data]);

  useEffect(() => {
    if (language) {
      fetchWidgetSettings(language);
    }
  }, [language, isBackToHoreca]);

  useEffect(() => {
    if (language) {
      // Checks if defaultLanguage is a non-empty string
      fetchWidgetSettingsDetails(language);
    }
  }, [language]);
  
  useEffect(() => {
    if (language)
      fetchWidgetTitleandInfo(data?.idWidgetSetup,language);
  }, [language]);

  useEffect(() => {
    if (
      WidgetSetting?.length > 0 &&
      totalCount > 0 &&
      !isAddGuest &&
      !isBackToHoreca
    ) {
      getUnavailableCalenderDetails();
    }
  }, [WidgetSetting, totalCount, isAddGuest, isBackToHoreca]);

  useEffect(() => {
    if (!isBackToHoreca) {
      fetchReservationType();
    }
  }, [
    totalCount,
    adult,
    child,
    kid,
    toddler,
    defaultLanguage,
    selectedDate,
    isBackToHoreca,
  ]);

  useEffect(() => {
    document.body.setAttribute("style", "background-color: transparant;");
    const resReqMin = WidgetSetting?.find(
      (item) => item?.tag == "reservationRequest"
    )?.data;
    setResReqMin(resReqMin == null ? "22" : resReqMin);
  }, [WidgetSetting]);

  function calculateEndTime(startTime, secondsToAdd) {
    return dayjs(`1970-01-01 ${startTime}`)
      .add(secondsToAdd, "second")
      .format("HH:mm:ss");
  }

  const fetchCombinations = async () => {
    dispatch(setCombinationList([]));
    const endTime = calculateEndTime(time, reservType?.duration);
    const parsedDate = dayjs(selectedDate, "DD-MM-YYYY", true);
    // Check if date is valid
    if (!parsedDate?.isValid()) {
      return;
    }
    // Format the valid date into 'YYYY-MM-DD'
    const formattedDate = parsedDate.format("YYYY-MM-DD");
    const payload = {
      key: data?.key,
      idreservationtype: parseInt(reservType?.idreservationtype),
      ArrivalDate: formattedDate,
      ArrivalTime: time,
      DepatureTime: endTime,
      Field1: parseInt(adult),
      Field2: parseInt(child),
      Field3: parseInt(kid),
      Field4: parseInt(toddler),
      Field5: parseInt(baby),
      LanguageCode: language,
      NoOfGuest: parseInt(totalCount),
    };
    try {
      const response = await getCombinationList(payload);
      dispatch(setCombinationList(response));
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (time) fetchCombinations();
  }, [time]);

  const resetReservationData = () => {
    dispatch(setIsBackToHoreca(false));
    if (blockedDates?.length > 0) dispatch(updateBlockedDates([]));
    if (reservationTypeDatas?.length > 0) dispatch(setReservationTypeDatas([]));
    if (reservationGroupData?.length > 0)
      dispatch(setReservationGroupDatas([]));
    if (freeTablesData?.length > 0) dispatch(setFreeTablesData([]));
    if (Object?.keys(reservType)?.length > 0)
      dispatch(updateReservationType({}));
    if (selectedDate?.trim() !== "") dispatch(updateSelectedDate(""));
    if (time?.trim() !== "") dispatch(updateTime(""));
    if (reservGroup && Object?.keys(reservGroup)?.length > 0)
      dispatch(updateReservationGroup({}));
  };

  useEffect(() => {
    dispatch(updateTotalCount(adult));
  }, [adult]);
  useEffect(() => {
    if (adult > 10) {
      dispatch(
        checkGuestLimit({
          guestType: "adult",
          isGreaterThan10: true,
        })
      );
    } else {
      dispatch(
        checkGuestLimit({
          guestType: "adult",
          isGreaterThan10: false,
        })
      );
    }
  }, [adult]);

  const fetchReservationGroupDetails = async () => {
    const parsedDate = dayjs(selectedDate, "DD-MM-YYYY");
    const formattedDate = parsedDate.format("YYYY-MM-DD");
    const [hours, minutes, seconds] = time.split(":");
    const date = new Date();
    date.setHours(hours, minutes, seconds, 0); // Set hours, minutes, and seconds
    const formattedTime = date.toTimeString().slice(0, 8); // Extracts HH:mm:ss
    const payload = {
      idreservationtype: parseInt(reservType.idreservationtype) ?? 0,
      date: "2024-11-10",
      key: data?.key,
      time: formattedTime,
      lang: language,
    };
    try {
      const response = await getReservationGroup(payload);
      if (response?.status != 200 || !response?.data) {
        throw new Error("Couldn't get reservation group");
      }
      dispatch(setReservationGroupDatas(response?.data));
    } catch (error) {
      console.error("error fetching reservation group : ", error?.message);
    }
  };

  useEffect(() => {
    if (Object.keys(reservType).length > 0 && time && !isBackToHoreca) {
      fetchReservationGroupDetails(); // Fetch reservation group details when reservation type, selected date and time are available
    }
  }, [reservType, time, isBackToHoreca,language]);
  useEffect(() => {
    if (
      reservationGroupData?.length == 1 ||
      !widgetConfig?.settings?.showReservationGroup
    ) {
      dispatch(updateReservationGroup(reservationGroupData[0])); // Update reservation group details when reservation group data is available
    }
  }, [reservationGroupData]);
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {nonEmptyFields.length <= 1 ? (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControl
            fullWidth
            sx={{
              width: "100%",
              height: "70px",
              
              position: "relative",
              backgroundColor: theme?.guest?.bgColor,
            //   "& .MuiOutlinedInput-notchedOutline": {
            //     border: `1px solid ${theme?.widget?.inputBorderColor}`,
            // },

            // Ensure the input itself doesn't have a border
            "& .MuiInputBase-root": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              boxShadow: "none",
            },

            // Remove border on focus
            "& .Mui-focused": {
              border: "none",
              boxShadow: "none",
            },
            }}
          >
            {isGreaterThan10?.adult ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: "0.1rem", sm: "0.2rem" },
                }}
              >
                <IconButton
                  aria-label="add-icon"
                  sx={{
                    color: theme?.guest?.textColor,
                    position: "absolute",
                    left: "3rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                  }}
                  onClick={(event) => {
                    event.stopPropagation(); // Prevent TextField click
                    if (adult > 1) {
                      resetReservationData();
                      dispatch(
                        setGuestCount({
                          guestType: "adult",
                          count: adult - 1,
                        })
                      );
                    }
                  }}
                >
                  <RemoveCircleIcon />
                </IconButton>
                <Typography
                  sx={{
                    position: "absolute",
                    top: 10,
                    left: 20,
                    fontSize: "12px",
                    color: theme?.widget?.inputTextColor,
                    fontWeight: 200,
                  }}
                >
                  {languageWords?.Guest}
                </Typography>
                <TextField
                  sx={{
                    position: "relative",
                    height: "30px",
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: theme?.guest?.dropdownBorderColor,
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: theme?.guest?.dropdownBorderColor,
                      },
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: 1,
                      textAlign: "center",
                      py: 3,
                      color: "#9F9F9F",
                      border: "none",
                    },
                  }}
                  placeholder="00"
                  name="adult"
                  value={adult}
                  disabled={true}
                />
                <IconButton
                  aria-label="add-icon"
                  sx={{
                    color: theme?.guest?.textColor,
                    position: "absolute",
                    right: "3rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                  }}
                  onClick={() => {
                    resetReservationData();
                    dispatch(
                      setGuestCount({
                        guestType: "adult",
                        count: adult + 1,
                      })
                    );
                  }}
                >
                  <AddCircleIcon />
                </IconButton>
              </Box>
            ) : (
              <Box>
                <Typography
                  sx={{
                    position: "absolute",
                    top: 10,
                    left: 20,
                    fontSize: "12px",
                    color: theme?.widget?.inputTextColor,
                    fontWeight: 200,
                  }}
                >
                  {languageWords?.Guest}
                </Typography>
                <KeyboardArrowDownIcon
                  sx={{
                    position: "absolute",
                    top: 20,
                    right: 20,
                  }}
                />

                <Select
                  id="demo-simple-select"
                  value={adult}
                  fullWidth
                  // IconComponent={KeyboardArrowDownIcon}
                  IconComponent={null} // Remove the default arrow icon
                  sx={{
                    position: "relative",

                    width: "100%",
                    height: "72px",
                    "& .MuiOutlinedInput-input": {
                      padding: 1,
                      color: theme?.guest?.textColor,
                      ml: 3,
                      mt: 1,
                      fontSize: { sm: "12px", md: "14px" },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove default border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none !important", // Ensure no border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure no border on focus
                    },
                  }}
                  onChange={(event) => {
                    resetReservationData();
                    dispatch(
                      setGuestCount({
                        guestType: "adult",
                        count: Number(event.target.value),
                      })
                    );
                  }}
                >
                  {new Array(10).fill(null).map((_, index) => (
                    <MenuItem
                      key={index}
                      value={index + 1}
                      sx={{
                        color: theme?.guest?.dropdownTextColor,
                        width: "100%",
                        fontSize: { sm: "12px", md: "1.2rem" },
                        "&:hover": {
                          backgroundColor: theme?.guest?.dropdownBgHover,
                          color: theme?.guest?.dropdownTextColorHover,
                        },
                      }}
                    >
                      {index + 1}
                    </MenuItem>
                  ))}
                  <MenuItem
                    value={11}
                    sx={{
                      color: theme?.guest?.dropdownTextColor,
                      fontSize: { sm: "12px" },
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      dispatch(
                        checkGuestLimit({
                          guestType: "adult",
                          isGreaterThan10: true,
                        })
                      );
                      dispatch(
                        setGuestCount({
                          guestType: "adult",
                          count: 11,
                        })
                      );
                    }}
                  >
                    <AddBoxTwoToneIcon
                      sx={{
                        color: theme?.guest?.plusColor,
                        width: { xs: 16, sm: 20 },
                        height: { xs: 16, sm: 20 },
                        "&:hover": {
                          color: theme?.guest?.plusHover,
                        },
                      }}
                    />
                  </MenuItem>
                </Select>
              </Box>
            )}
          </FormControl>
        </Grid>
      ) : (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <SelectComponent
            label={languageWords?.Guest}
            value={totalCount}
            onClick={() => {
              setIsAddGuest(!isAddGuest);
            }}
            ref={guestRef}
            sx={{
              position: "relative",
              width: "100%",
              height: "72px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "& .MuiOutlinedInput-input": {
                padding: 1,
                color: theme?.guest?.textColor,
                ml: 3,
                mt: 1,
                fontSize: { sm: "12px", md: "14px" },
              },
            }}
          />

          <Addguest
            isOpen={isAddGuest}
            handleClose={() => setIsAddGuest(false)}
            Ref={guestRef.current}
          />
        </Grid>
      )}

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <SelectComponent
          label={languageWords?.date}
          value={selectedDate?.trim() != "" ? selectedDate : "DD-MM-YYYY"}
          onClick={() => setIsDateDropdownOpen(!isDateDropdownOpen)}
          ref={dateRef}
          disabled={totalCount > 0 ? false : true}
          sx={{
            position: "relative",

            width: "100%",
            height: "72px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "& .MuiOutlinedInput-input": {
              padding: 1,
              color: theme?.guest?.textColor,
              ml: 3,
              mt: 1,
              fontSize: { sm: "12px", md: "14px" },
            },
          }}
        />
        <DateComponent
          isOpen={isDateDropdownOpen}
          handleClose={() => setIsDateDropdownOpen(false)}
          Ref={dateRef.current}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <SelectComponent
          label={languageWords?.reserveType}
          value={
            reservType &&
            typeof reservType === "object" &&
            Object.keys(reservType).length > 0
              ? reservType?.name
              : "Type"
          }
          onClick={() => {
            // setAnchorPosition(reservationType);
            setIsReservationType(!isReservationType);
          }}
          ref={reservationType}
          disabled={selectedDate?.trim() != "" ? false : true}
          sx={{
            position: "relative",

            width: "100%",
            height: "72px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "& .MuiOutlinedInput-input": {
              padding: 1,
              color: theme?.guest?.textColor,
              ml: 3,
              mt: 1,
              fontSize: { sm: "12px", md: "14px" },
            },
          }}
        />
        <ReservationType
          isOpen={isReservationType}
          handleClose={() => setIsReservationType(false)}
          Ref={reservationType.current}
          isLoading={reservTypeLoading}
          isCombination={true}
          lang={language}
          Id={id}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <SelectComponent
          label={languageWords?.Time}
          value={time?.trim() != "" ? time?.substring(0, 5) : "HH:MM"}
          onClick={() => setIsTimeComponent(!isTimeComponent)}
          ref={timeRef}
          disabled={
            reservType &&
            typeof reservType === "object" &&
            Object.keys(reservType).length > 0
              ? false
              : true
          }
          sx={{
            position: "relative",

            width: "100%",
            height: "72px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: `1px solid ${theme?.widget?.inputBorderColor}`,
            },
            "& .MuiOutlinedInput-input": {
              padding: 1,
              color: theme?.guest?.textColor,
              ml: 3,
              mt: 1,
              fontSize: { sm: "12px", md: "14px" },
            },
          }}
        />
        <TimeComponent
          isOpen={isTimeComponent}
          handleClose={() => setIsTimeComponent(false)}
          Ref={timeRef.current}
        />
      </Grid>

      {widgetConfig?.settings?.showReservationGroup && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
          <SelectComponent
            label={languageWords?.reserveGroup}
            value={
              reservGroup &&
              typeof reservGroup === "object" &&
              Object.keys(reservGroup).length > 0
                ? reservGroup?.name
                : "Group"
            }
            onClick={() => setIsTypeGroup(!isGrouptype)}
            ref={reservationGroupRef}
            disabled={time?.trim() != "" ? false : true}
            sx={{
              position: "relative",

              width: "100%",
              height: "72px",
              "& .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: `1px solid ${theme?.widget?.inputBorderColor}`,
              },
              "& .MuiOutlinedInput-input": {
                padding: 1,
                color: theme?.guest?.textColor,
                ml: 3,
                mt: 1,
                fontSize: { sm: "12px", md: "14px" },
              },
            }}
          />
          <ReservationGroup
            isOpen={isGrouptype}
            handleClose={() => setIsTypeGroup(false)}
            Ref={reservationGroupRef.current}
            disabled={
              reservGroup &&
              typeof reservGroup === "object" &&
              Object.keys(reservGroup).length > 0
                ? false
                : true
            }
          />
        </Grid>
      )}

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Button
          variant="contained"
          fullWidth
          sx={{
            height: "70px",
            backgroundColor:
              reservType &&
              typeof reservType === "object" &&
              Object.keys(reservType).length > 0 &&
              totalCount > 0 &&
              selectedDate?.trim() != "" &&
              time?.trim() != ""
                ? theme?.widget?.bookNowbtnBgActive
                : theme?.widget?.bookNowBtnBg,
            color:
              reservType &&
              typeof reservType === "object" &&
              Object.keys(reservType).length > 0 &&
              totalCount > 0 &&
              selectedDate?.trim() != "" &&
              time?.trim() != ""
                ? theme?.widget?.booknowBtnTextColorActive
                : theme?.widget?.booknowBtnTextColor,
            fontWeight: "bold",
            display: "flex", // Ensure flexbox is used
            flexDirection: "column", // Align content in a column (Book Now on top, €25,00 below)
            justifyContent: "center", // Center the text vertically
            alignItems: "center", // Center the text horizontally
          }}
          onClick={() => {
            if (
              reservType &&
              typeof reservType === "object" &&
              Object.keys(reservType).length > 0 &&
              totalCount > 0 &&
              selectedDate?.trim() != "" &&
              time?.trim() != ""
            ) {
              navigate(`/bookNow`);
            } else {
              return;
            }
          }}
        >
          {languageWords?.Booknow}
          {reservType?.totalCost > 0 &&
            totalCount < widgetConfig?.reservationRequestMin && (
              <Box component="span" fontSize="13px" fontWeight="200">
                €{parseFloat(reservType?.totalCost).toFixed(2)}
              </Box>
            )}
        </Button>
      </Grid>
    </Grid>
  );
};

export default HorecaComponent;
